// project imports
import { getIriFromObj, processDateFieldInput, processDateFieldOutput } from 'utils/processors';

export const processEntityInput = (values) => ({
    deletedAt: 'deletedAt' in (values || {}) ? processDateFieldInput(values.deletedAt) : null
});

export const processEntityOutput = (values) => ({
    deletedAt: 'deletedAt' in (values || {}) ? processDateFieldOutput(values.deletedAt, 'yyyy-MM-dd HH:mm') : undefined,
    deletedBy: 'deletedBy' in (values || {}) ? getIriFromObj(values.deletedBy) : undefined
});
